import { render } from "./Versions.vue?vue&type=template&id=2669aa15&scoped=true"
import script from "./Versions.vue?vue&type=script&lang=js"
export * from "./Versions.vue?vue&type=script&lang=js"

import "./Versions.vue?vue&type=style&index=0&id=2669aa15&scoped=true&lang=css"

import exportComponent from "C:\\job\\ems-ISO-final\\frontend_ems\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2669aa15"]])

export default __exports__